import React from 'react';
import PropTypes from 'prop-types';
// import SVGInline from 'react-svg-inline';
// import ScrollArea from 'react-scrollbar';
import ScrollArea from 'react-scrollbar-simple-rich';

// components

// svgs
// import clockSVG from '../../../inlineSVGs/clockSVG';

// utils
import {insertLinksToText, isMobile} from '../../../../utils';

// styles

import './DescriptionBox.css';
import {ButtonSimple} from "../../../Elements/Buttons";

const TEXT_BEFORE_SEE_MORE = 352;

const DescriptionBox = ({
                        text,
                        wrapperStyle,
                        isMobileSeeMore,
                        customClass = '',
                        handleToggleSeeMore = () => {},
                        onScroll = () => {}
}) => {

    const onScrollFix = event => {


        onScroll(event);
    };

    if (!text || text.length < 1) return null;

    const textWithLinks = insertLinksToText(text);

    if (!isMobile()) {
        return (
            <div className={`modal-description-wrapper rtl ${customClass}`} style={wrapperStyle}>
                <ScrollArea
                    vertical
                    stopScrollPropagation
                    speed={0.8}
                    className="scroll-desc"
                    contentClassName="scroll-content-desc"
                    horizontal={false}
                    onScroll={val => onScrollFix(val)}
                    maxScrollSize={9}
                >
                    <div unselectable="on" className="box" dangerouslySetInnerHTML={{__html: textWithLinks}}>

                    </div>
                </ScrollArea>
            </div>
        )
    }

    return (
        <div className={`modal-description-wrapper ${isMobileSeeMore ? 'open' : ''} ${customClass}`} style={wrapperStyle}>
            <div
                unselectable="on"
                className={`box text`}
                dangerouslySetInnerHTML={{__html: textWithLinks}}
            />
            {textWithLinks.length > TEXT_BEFORE_SEE_MORE ?
                <div className={'see-more-wrapper'}>

                    <ButtonSimple
                        onPress={() => handleToggleSeeMore()}
                        label={isMobileSeeMore ? 'הראה פחות' : 'הראה עוד'}
                    />
                    {/*<button className={'see-more-btn'} onClick={() => handleToggleSeeMore()}>*/}
                    {/*    {isMobileSeeMore ? 'See Less' : 'See More'}*/}
                    {/*</button>*/}
                </div>
            : null}

        </div>
    )
};

DescriptionBox.propTypes = {
    text: PropTypes.string,
    wrapperStyle: PropTypes.object,
    onScroll: PropTypes.func,
    customClass: PropTypes.string,
    isMobileSeeMore: PropTypes.bool,
    handleToggleSeeMore: PropTypes.func
};

export default DescriptionBox;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/DescriptionBox/DescriptionBox.js